import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "cong_ty_lu_hanh";

moduleApi.create = (dataForm) => { 
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.updateLock = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
        success: "Khóa thành công", //string | null | comment
        error: "",  //string | null | comment
      },
  };
  return ApiService(api);
};

moduleApi.updateUnLock = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
        success: "Mở Khóa thành công", //string | null | comment
        error: "",  //string | null | comment
      },
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.countDanhGia = (ids) => {
  let api = {
    module: moduleName,
    type: "saodanhgia",
    value: {listId: ids}
  }
  return ApiService(api);
};

moduleApi.getViewStatistics = () => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "dashboard_getStatistics",
    value: {}
  };
  return ApiService(api);
};


export default moduleApi;
